(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svrn-product-commerce"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-svrn-commerce]').forEach((section) => {
    section.querySelectorAll('[data-gallery-trigger]').forEach((trigger) => trigger.addEventListener('click', () => {
      const key = trigger.dataset.galleryTrigger;
      section.querySelectorAll('[data-gallery-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.galleryPanel === key));
      section.querySelectorAll('[data-gallery-trigger]').forEach((button) => button.classList.toggle('is-active', button === trigger));
    }));
    const input = section.querySelector('input[name="quantity"]');
    section.querySelectorAll('[data-bundle-selector] input[type="radio"]').forEach((radio) => radio.addEventListener('change', () => {
      if (input) input.value = radio.value;
      section.querySelectorAll('.svrn-commerce__bundle').forEach((option) => option.classList.toggle('is-selected', option.contains(radio)));
    }));
    section.querySelector('[data-qty-minus]')?.addEventListener('click', () => { input.value = String(Math.max(1, Number(input.value || 1) - 1)); });
    section.querySelector('[data-qty-plus]')?.addEventListener('click', () => { input.value = String(Math.min(9, Number(input.value || 1) + 1)); });
    const original = section.querySelector('[data-original-cta]');
    const sticky = section.querySelector('[data-sticky-buy]');
    section.querySelector('[data-sticky-submit]')?.addEventListener('click', () => original?.click());
    if (original && sticky && 'IntersectionObserver' in window) {
      let originalPassed = false;
      let footerVisible = false;
      const renderSticky = () => sticky.classList.toggle('is-visible', originalPassed && !footerVisible);
      new IntersectionObserver(([entry]) => {
        originalPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        renderSticky();
      }, { threshold: 0 }).observe(original);
      const footer = document.querySelector('footer, #shopify-section-footer-group');
      if (footer) new IntersectionObserver(([entry]) => {
        footerVisible = entry.isIntersecting;
        renderSticky();
      }, { threshold: 0 }).observe(footer);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svrn-video-stories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-svrn-motion]').forEach((section) => {
    const videos = [...section.querySelectorAll('video')];
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio > .72) {
        videos.forEach((item) => { if (item !== video) item.pause(); });
        video.muted = true;
        video.play().catch(() => {});
      } else video.pause();
    }), { threshold: [.25, .72] });
    videos.forEach((video) => observer.observe(video));
  });

  } catch(e) { console.error(e); }
})();
})();
